import React, { Component } from 'react';

import { Navbar } from '../components/shared/Navbar';
import { Footer } from '../components/shared/Footer';

import { AppContext } from '../contexts/AppContext';

import { getViewportSize, getViewportType } from '../helpers/ViewportHelpers';

import '../../css/general.scss';
import '../../css/components/wrappers/page-wrapper.scss';
export class PageWrapper extends Component {
  static contextType = AppContext;

  componentDidMount() {
    this.viewportChangeHandler();
    window.addEventListener('resize', this.viewportChangeHandler);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.viewportChangeHandler);
  }

  viewportChangeHandler = () => {
    const {
      updateState,
    } = this.context;

    const newState = {
      viewportSize: getViewportSize(),
      viewportType: getViewportType(),
    }

    updateState(newState);
  } 

  render() {
    return (
      <div className="page-wrapper">
        { !this.props.hideNavbar &&
          <Navbar homePage={ this.props.homePage } darkTheme={ this.props.darkTheme }/>
        }

        <div className="main-content">
          { this.props.children }
        </div>

        { !this.props.hideFooter &&
          <Footer />
        }
      </div> 
    )
  }
}
